/**
 * Author : zhengyanfeng.
 * Date   : 2021/1/5.
 * File   : citys. 城市id对象
 */
import fujian from './fujian'
import zhejiang from './zhejiang'

console.log('fujian:', fujian)

export default Object.assign(fujian,zhejiang)



//////////////////
// WEBPACK FOOTER
// ./static/mapPoint/diningPoint/index.js
// module id = null
// module chunks = 